import { BaseFunctionService } from './BaseFunctionService';

export interface ISaldoResult {
     success: boolean;
     message: string;
     saldo_anterior?: number;
     saldo_atual?: number;
     movimentacao_id?: number;
}

export interface ILimiteAlunoResult {
     pode_comprar: boolean;
     valor_limite_diario: number;
     valor_gasto_hoje: number;
     valor_disponivel: number;
     message: string;
}

/**
 * Serviço para funções relacionadas a saldos e créditos
 */
export class SaldoFunctionsService extends BaseFunctionService {
     
     /**
      * Adiciona crédito ao responsável
      */
     /**
      * Adiciona crédito ao responsável
      * @param idResponsavel ID do responsável financeiro
      * @param valor Valor do crédito
      * @param idOrganizacao Organização
      * @param descricao Descrição
      * @param createdBy Usuário que criou
      * @param tipoOrigem Tipo da origem (ex: 'deposito', 'pagamento')
      * @param origemId ID de origem (ex: id do pagamento)
      */
     async adicionarCreditoResponsavel(
          idResponsavel: number,
          valor: number,
          idOrganizacao: number,
          descricao: string = 'Depósito de crédito',
          createdBy?: number,
          tipoOrigem: string = 'deposito',
          origemId?: number | null
     ): Promise<ISaldoResult> {
          return await this.rpc('fn_adicionar_credito_responsavel', {
               p_id_responsavel: idResponsavel,
               p_valor: valor,
               p_id_organizacao: idOrganizacao,
               p_descricao: descricao,
               p_created_by: createdBy,
               p_tipo_origem: tipoOrigem,
               p_origem_id: origemId ?? null
          });
     }

     /**
      * Transfere crédito do responsável para o aluno
      */
     async transferirCreditoParaAluno(
          idResponsavel: number,
          idAluno: number,
          valor: number,
          idOrganizacao: number,
          createdBy?: number
     ): Promise<ISaldoResult> {
          return await this.rpc('fn_transferir_credito_para_aluno', {
               p_id_responsavel: idResponsavel,
               p_id_aluno: idAluno,
               p_valor: valor,
               p_id_organizacao: idOrganizacao,
               p_created_by: createdBy
          });
     }

     /**
      * Verifica se o aluno pode realizar uma compra considerando seus limites
      */
     async verificarLimiteAluno(
          idAluno: number,
          valorCompra: number,
          idOrganizacao: number
     ): Promise<ILimiteAlunoResult> {
          return await this.rpc('fn_verificar_limite_aluno', {
               p_id_aluno: idAluno,
               p_valor_compra: valorCompra,
               p_id_organizacao: idOrganizacao
          });
     }
}

// Instância singleton
export const saldoFunctionsService = new SaldoFunctionsService();
